// extracted by mini-css-extract-plugin
export default {"sort":"XP-z","sortSelect":"YP-z","disabled":"ZP-z"};